import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import MessageDetails from "../../../../containers/MessageDetails";
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {reactTableText} from '../../../../constants/configs';
import {keyBy, mapValues, omit} from "lodash";
import Api from "../../../../services/Api";
import ReactTable from 'react-table';
import {i18nizeDate} from "../../../../helpers/Utils";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      pages: -1,
      loading: false,
      expanded: {},
    };
  }

  fetchData = async state => {
    const {match, location} = this.props;
    const {userId} = location.state;
    const {id} = match.params;
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/notifications/actions',
        null,
        {
          params: {
            notificationId: id,
            recipientValue: userId,
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
          }
        }
      );
      this.setState({
        messages: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getColumns = t => [
    {
      Header: t('Id'),
      accessor: 'id',
    },
    {
      Header: t('Channel'),
      accessor: 'action.channel',
    },
    {
      Header: t('Status'),
      accessor: 'action.status',
    },
    {
      Header: t('Process Date'),
      accessor: 'processedAt',
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "----------"}</span>,
    },
    {
      Header: t('Delivery Date'),
      accessor: 'deliveredAt',
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "----------"}</span>,
    },
    {
      Header: t('Seen Date'),
      accessor: 'seenAt',
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "----------"}</span>,
    },
  ];

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  render() {
    const {t, match} = this.props;
    const {messages, loading, pages, expanded} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={messages}
                  pages={pages}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  expanded={expanded}
                  onExpandedChange={this.onExpanded}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={10}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={({original}) => {
                    return (
                      <MessageDetails message={original}/>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
